// Types
import type { PricingPackage, OrderCalculations } from "@/types/types";

export function useOrderCalculations(
  pricingPackage: PricingPackage | null,
  isDiscountApplied: boolean,
  MultiplyWarranty: boolean,
  warrantyState: boolean,
  formattedString?: string,
): OrderCalculations | null {
  if (!pricingPackage) return null;

  const oldPrice = Number(pricingPackage.old_price);
  const productAmount = Number(pricingPackage.amount);
  const price = Number(pricingPackage.price) * productAmount;

  const promoPrice =
    isDiscountApplied && pricingPackage.promo_discounted_price != null
      ? Number(pricingPackage.promo_discounted_price) * productAmount
      : 0;

  const productPrice = isDiscountApplied ? promoPrice : price;

  const warrantyPrice = !MultiplyWarranty
    ? Number(pricingPackage.warranty_price)
    : Number(pricingPackage.warranty_price) * productAmount;

  const warranty = warrantyState ? warrantyPrice : 0;

  const subtotal = productPrice + warranty;
  const shippingPrice =
    isDiscountApplied && pricingPackage.promo_shipping_price != null
      ? Number(pricingPackage.promo_shipping_price)
      : Number(pricingPackage.shipping_price);

  let totalSavings =
    oldPrice -
    productPrice +
    (isDiscountApplied && pricingPackage.promo_shipping_price != null
      ? Number(pricingPackage.shipping_price) -
        Number(pricingPackage.promo_shipping_price)
      : 0);

  if (
    pricingPackage.enable_fake_products &&
    pricingPackage.fake_products?.length
  ) {
    const fakeProductsPrice = pricingPackage.fake_products.reduce(
      (acc, fp) => acc + (Number(fp.price) || 0),
      0,
    );
    totalSavings += fakeProductsPrice;
  }

  const totalNumeric = (subtotal + shippingPrice).toFixed(2);

  return {
    savings: formattedString
      ? formattedString.replace(/(0\.00|0,00|0)/, totalSavings.toFixed(2))
      : totalSavings.toFixed(2),
    subtotal: formattedString
      ? formattedString.replace(/(0\.00|0,00|0)/, subtotal.toFixed(2))
      : subtotal.toFixed(2),
    total: formattedString
      ? formattedString.replace(
          /(0\.00|0,00|0)/,
          (subtotal + shippingPrice).toFixed(2),
        )
      : (subtotal + shippingPrice).toFixed(2),
    shipping: formattedString
      ? formattedString.replace(/(0\.00|0,00|0)/, shippingPrice.toFixed(2))
      : shippingPrice.toFixed(2),
    total_numeric: totalNumeric,
  };
}
